import { Link } from "react-router-dom";
import { Truck, ShieldCheck, Eye, Ruler } from "lucide-react";
import { TEMPLATES, SIZES, DELIVERY_DELAY, PANEL_MATERIAL } from "@/lib/poster";
import { WHATSAPP_URL, WHATSAPP_DISPLAY, INSTAGRAM_URL, INSTAGRAM_HANDLE, WhatsAppIcon, InstagramIcon } from "@/components/Social";

const promises = [
  { icon: Eye, title: "Aperçu fidèle", text: "Le fichier imprimé est généré à partir de l'aperçu que vous validez." },
  { icon: ShieldCheck, title: "Photos respectées", text: "Seul l'arrière-plan est retiré, aucune retouche des personnes." },
  { icon: Truck, title: "Livraison", text: `Votre tableau livré sous ${DELIVERY_DELAY}.` },
];

const Col = ({ title, children }) => (
  <div className="space-y-4">
    <h4 className="text-[11px] uppercase tracking-[0.3em] text-white/75">{title}</h4>
    <ul className="space-y-3 text-sm text-white">{children}</ul>
  </div>
);
const FLink = ({ to, children, id }) => (
  <li><Link to={to} data-testid={id} className="hover:text-[#EADFD3] hover:underline underline-offset-4 transition-colors duration-200">{children}</Link></li>
);

export const Footer = () => (
  <footer className="grad-footer text-white" data-testid="site-footer">
    <div className="grad-ivory text-[#3A322B] border-y border-[#DDD3C6]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-3 gap-10">
        {promises.map((p) => (
          <div key={p.title} className="text-center">
            <div><p className="font-display text-lg uppercase tracking-[0.12em] text-[#3A322B] flex items-center justify-center gap-3"><p.icon size={20} className="text-[#7B5338] shrink-0" />{p.title}</p><p className="text-sm text-[#6B5F53] mt-1 leading-relaxed">{p.text}</p></div>
          </div>
        ))}
      </div>
    </div>

    <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 lg:grid-cols-12 gap-10">
      <div className="col-span-2 lg:col-span-4 space-y-5">
        <p className="font-display text-3xl tracking-[0.15em] text-white">MS SIGNATURE</p>
        <p className="text-sm text-white/80 leading-relaxed max-w-sm">Tableaux personnalisés pour vos mariages, fiançailles, anniversaires et souvenirs — composés par vous, imprimés avec soin.</p>
        <div className="space-y-2 text-sm" data-testid="footer-socials">
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:underline underline-offset-4" data-testid="footer-instagram-link"><InstagramIcon size={18} /> {INSTAGRAM_HANDLE}</a>
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:underline underline-offset-4" data-testid="footer-whatsapp-link"><WhatsAppIcon size={18} /> {WHATSAPP_DISPLAY}</a>
        </div>
      </div>
      <div className="lg:col-span-2">
        <Col title="Navigation">
          <FLink to="/" id="footer-home-link">Accueil</FLink>
          <FLink to="/modeles" id="footer-models-link">Nos modèles</FLink>
          <FLink to="/suivi" id="footer-tracking-link">Suivi de commande</FLink>
        </Col>
      </div>
      <div className="lg:col-span-3">
        <Col title="Nos modèles">
          {TEMPLATES.map((t) => <FLink key={t.id} to={`/configurateur?modele=${t.id}`} id={`footer-template-${t.id}`}>{t.name}</FLink>)}
        </Col>
      </div>
      <div className="lg:col-span-3">
        <Col title="Formats & délais">
          {SIZES.map((s) => <li key={s.id} className="flex items-center gap-2"><Ruler size={14} className="text-white/80" /> {s.label} — {s.price} €</li>)}
          <li className="flex items-center gap-2"><Truck size={14} className="text-white/80" /> Livraison offerte : {DELIVERY_DELAY}</li>
          <li className="text-xs text-white/80">{PANEL_MATERIAL} — trépied et support non fournis</li>
        </Col>
      </div>
    </div>

    <div className="border-t border-white/25">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-6 flex flex-wrap justify-between gap-4 text-xs text-white/80">
        <span>© {new Date().getFullYear()} MS SIGNATURE — Tous droits réservés</span>
        <Link to="/cgv" className="hover:text-white hover:underline underline-offset-4 transition-colors" data-testid="footer-terms-link">Conditions générales de vente</Link>
        <Link to="/atelier" className="hover:text-white transition-colors" data-testid="footer-admin-link">Espace atelier</Link>
      </div>
    </div>
  </footer>
);
